import * as React from 'react';
import { Button } from 'kui';
import { IButtonLargeProps } from './types';
import {useEffect} from 'react';

export const ButtonLarge: React.FunctionComponent<IButtonLargeProps> = ({
    size = 'large',
    text,
    onClick,
    onDidMount
}) => {
    useEffect(() => {
        if (onDidMount) {
            onDidMount();
        }
    }, []);

    return (
        <Button
            size={size}
            onClick={onClick}
        >
            {text}
        </Button>
    )
};
